var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.47594 0.905061C2.19563 0.672561 1.80562 0.622873 1.4775 0.775686C1.14844 0.930373 0.9375 1.26131 0.9375 1.62506V20.3751C0.9375 20.7388 1.14844 21.0697 1.4775 21.2244C1.60406 21.2835 1.73906 21.3126 1.875 21.3126C2.08969 21.3126 2.30344 21.2385 2.47594 21.0951L13.7259 11.7201C13.9388 11.5419 14.0625 11.2785 14.0625 11.0001C14.0625 10.7216 13.9388 10.4582 13.7259 10.2801L2.47594 0.905061ZM2.8125 18.3735V3.62662L11.6606 11.0001L2.8125 18.3735Z",
    fill: "#C70048"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 0.6875H16.875C16.3566 0.6875 15.9375 1.1075 15.9375 1.625V20.375C15.9375 20.8925 16.3566 21.3125 16.875 21.3125H20.625C21.1434 21.3125 21.5625 20.8925 21.5625 20.375V1.625C21.5625 1.1075 21.1434 0.6875 20.625 0.6875ZM19.6875 19.4375H17.8125V2.5625H19.6875V19.4375Z",
    fill: "#C70048"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 0.6875H24.375C23.8566 0.6875 23.4375 1.1075 23.4375 1.625V20.375C23.4375 20.8925 23.8566 21.3125 24.375 21.3125H28.125C28.6434 21.3125 29.0625 20.8925 29.0625 20.375V1.625C29.0625 1.1075 28.6434 0.6875 28.125 0.6875ZM27.1875 19.4375H25.3125V2.5625H27.1875V19.4375Z",
    fill: "#C70048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.21cc2e46edae4f4b92b3927291d2dcc4.svg";
export { ForwardRef as ReactComponent };